type IValidatorOtherDictionary = 'boolean' | 'required' | 'unique' | 'select'
type IBaseValidatorDictionary =
  | 'required_with_values'
  | 'required_with_all_values'
  | 'required_without_values'
  | 'required_without_all_values'
type IType = 'select'
type IFieldBaseType = 'checkbox' | 'string'
const flatFileButtonSettings = {
  type: 'Contact',
  fields: [
    {
      label: 'Email',
      key: 'email',
      validators: [
        { validate: 'required' as IValidatorOtherDictionary },
        { validate: 'unique' as IValidatorOtherDictionary },
      ],
    },
    {
      label: 'First Name',
      key: 'firstName',
      validators: [
        {
          validate: 'required' as IValidatorOtherDictionary,
        },
      ],
    },
    {
      label: 'Last Name',
      key: 'lastName',
      validators: [
        {
          validate: 'required' as IValidatorOtherDictionary,
        },
      ],
    },
    {
      label: 'Company',
      key: 'company',
    },
    {
      label: 'Title',
      key: 'title',
    },
    {
      label: 'Phone',
      key: 'phone',
    },
    {
      label: 'Industry',
      key: 'industry',
    },
    {
      label: 'Website',
      key: 'website',
    },
    {
      label: 'Status',
      key: 'status',
      type: 'select' as IType,
      validators: [
        {
          validate: 'required' as IValidatorOtherDictionary,
        },
      ],
      options: [
        {
          value: 'emailScheduled',
          label: 'Email Scheduled',
        },
        {
          value: 'dne',
          label: 'Do Not Engage',
        },
        {
          value: 'new',
          label: 'New',
        },
      ],
    },
    {
      label: 'Maneuver',
      key: 'maneuver',
      type: 'select' as IType,
      options: [
        {
          value: 'firstTouch',
          label: 'First Touch',
        },
        {
          value: 'followUp',
          label: 'Follow Up',
        },
        {
          value: 'nurture',
          label: 'Nurture',
        },
      ],
      validators: [
        {
          validate: 'required_with_values' as IBaseValidatorDictionary,
          fieldValues: { status: 'emailScheduled' },
        },
      ],
    },
    {
      label: 'Mission',
      key: 'mission',
      type: 'select' as IType,
      options: [
        {
          value: 'Mission 1',
          label: 'Mission 1',
        },
        {
          value: 'Mission 2',
          label: 'Mission 2',
        },
        {
          value: 'Mission 3',
          label: 'Mission 3',
        },
        {
          value: 'Mission 4',
          label: 'Mission 4',
        },
      ],
      validators: [
        {
          validate: 'required_with_values' as IBaseValidatorDictionary,
          fieldValues: { status: 'emailScheduled' },
        },
      ],
    },
    {
      label: 'Send Date',
      key: 'sendDate',
      validators: [
        {
          validate: 'required_with_values' as IBaseValidatorDictionary,
          fieldValues: { status: 'emailScheduled' },
        },
      ],
    },
    {
      label: 'Notify When Mission Completes',
      key: 'notifyOnComplete',
      type: 'checkbox' as IFieldBaseType,
      // validators: [
      //   {
      //     validate: 'required_with_values',
      //     fieldValues: { status: 'emailScheduled' },
      //   },
      // ],
    },
  ],
  managed: true,
}

export default flatFileButtonSettings
